export function primaryActionsFromRoleWorkplace(workplace) {
  const actions = workplace?.primary_actions;
  if (Array.isArray(actions)) return actions.filter(Boolean);
  const action = workplace?.primary_action;
  return action ? [action] : [];
}
